import { actionWithPayload, ActionWithPayload } from "state/action-types";
import { Body, PrivateMediaFileInfo, SourceFormat } from "api";
import { MediaWithCaption } from "util/media-with-caption";
import { RelNodeName } from "util/rel-node-name";
import { AndroidMediaUploadHandler } from "api/android/media-upload";
import { MediaUploadSource } from "state/mediaupload/media-source";

type MediaUploadSuccessHandler = (index: number, mediaFile: MediaWithCaption) => void;
type MediaUploadFailureHandler = (index: number) => void;
type MediaUploadProgressHandler = (index: number, loaded: number, total: number) => void;

export type RichTextEditorMediaUploadAction = ActionWithPayload<"RICH_TEXT_EDITOR_MEDIA_UPLOAD", {
    nodeName: RelNodeName | string;
    files: MediaUploadSource[];
    androidUpload?: AndroidMediaUploadHandler;
    compress: boolean;
    onSuccess: MediaUploadSuccessHandler;
    onFailure: MediaUploadFailureHandler;
    onProgress: MediaUploadProgressHandler;
    captionSrc?: Body | null;
    captionSrcFormat?: SourceFormat | null;
}>;
export const richTextEditorMediaUpload = (
    nodeName: RelNodeName | string,
    files: MediaUploadSource[],
    androidUpload: AndroidMediaUploadHandler | undefined,
    compress: boolean,
    onSuccess: MediaUploadSuccessHandler,
    onFailure: MediaUploadFailureHandler,
    onProgress: MediaUploadProgressHandler,
    captionSrc?: Body | null,
    captionSrcFormat?: SourceFormat | null
): RichTextEditorMediaUploadAction =>
    actionWithPayload(
        "RICH_TEXT_EDITOR_MEDIA_UPLOAD",
        {nodeName, files, androidUpload, compress, onSuccess, onFailure, onProgress, captionSrc, captionSrcFormat}
    );

type MediaRenameSuccessHandler = (media: PrivateMediaFileInfo) => void;
type MediaRenameFailureHandler = () => void;

export type RichTextEditorMediaRenameAction = ActionWithPayload<"RICH_TEXT_EDITOR_MEDIA_RENAME", {
    id: string;
    title: string;
    onSuccess: MediaRenameSuccessHandler;
    onFailure: MediaRenameFailureHandler;
}>;
export const richTextEditorMediaRename = (
    id: string,
    title: string,
    onSuccess: MediaRenameSuccessHandler,
    onFailure: MediaRenameFailureHandler
): RichTextEditorMediaRenameAction =>
    actionWithPayload("RICH_TEXT_EDITOR_MEDIA_RENAME", {id, title, onSuccess, onFailure});

export type RichTextEditorAnyAction =
    RichTextEditorMediaUploadAction
    | RichTextEditorMediaRenameAction;
